import { createAxios } from '../lib/axiosFactory';
import { dataCollectionParser, dataParser } from '../lib/response/dataParser';
import { errorParser } from '../lib/response/errorParser';
import { ActionResponse } from '../lib/interfaces/actionResponse';
import { pick } from 'lodash';
import { formatCentsToDollars } from '../plugins/number-filters';

export const state = {
  products: undefined
};

export const getters = {
  getAllProductDescriptions(state): string[] {
    return state.products.map(x => `${x.title} $${x.displayPrice}`);
  },
  getProductDescription: state => id => {
    return state.products
      .filter(x => x.id === id)
      .map(x => `${x.title} $${x.displayPrice}`)[0];
  },
  getProductUrlFromText: state => (text: string) => {
    return state.products?.find(x => text.indexOf(x.productUrl) > -1)
      ?.productUrl;
  },
  getProductDescriptionFromText: (state, getters) => (text: string) => {
    return getters.getAllProductDescriptions.find(x => text.indexOf(x) > -1);
  }
};

export const mutations = {
  setProducts(state: any, products: string) {
    state.products = products;
  }
};

export const actions = {
  async loadProducts({ commit }): Promise<ActionResponse> {
    try {
      commit('setProducts', undefined);
      const response = await createAxios(process.env.AppIntegrationsApiUrl).get(
        '/app-integrations/shopify-products-index'
      );

      const products = response.data.data.map(x => ({
        id: x.id,
        ...x.attributes,
        displayPrice: formatCentsToDollars(x.attributes?.usdPrice)
      }));

      commit('setProducts', products);
      return {
        success: true,
        errors: {},
        body: products
      };
    } catch (error) {
      return {
        success: false,
        errors: errorParser(error),
        body: error.response.data
      };
    }
  },

  async getProduct({ commit }, { productId }): Promise<ActionResponse> {
    try {
      const response = await createAxios(process.env.AppIntegrationsApiUrl).get(
        '/app-integrations/shopify-products-show',
        {
          params: {
            productId
          }
        }
      );
      return {
        success: true,
        errors: {},
        body: {
          id: response.data.data.id,
          ...response.data.data.attributes,
          displayPrice: formatCentsToDollars(
            response.data.data.attributes?.usdPrice
          )
        }
      };
    } catch (error) {
      return {
        success: false,
        errors: errorParser(error),
        body: error.response.data
      };
    }
  }
};
